import { FileUploadPassThroughOptions } from 'primereact/fileupload';
import { classNames } from 'primereact/utils';

export const PTFileUpload: FileUploadPassThroughOptions = {
  message: {
    root: {
      className: '!my-0',
    },
  },
  input: {
    className: 'hidden',
  },
  buttonbar: {
    className: classNames(
      'flex flex-wrap items-center justify-between',
      'ax-bg-green-10 ax-text-green p-2 ax-shadow rounded-tr-lg rounded-tl-lg gap-2',
    ),
  },
  basicButton: {
    className: classNames(
      'ax-btn ax-btn--secondary',
      'overflow-hidden relative',
    ),
  },
  chooseButton: {
    className: classNames('overflow-hidden relative flex items-center gap-2'),
  },
  chooseIcon: {
    className: 'mr-2 inline-block',
  },
  chooseButtonLabel: {
    className: 'flex-1 font-bold',
  },
  uploadButton: {
    root: {
      className: 'ax-btn',
    },
    icon: {
      className: 'mr-2',
    },
  },
  cancelButton: {
    icon: {
      className: 'mr-2',
    },
  },
  content: {
    className: classNames(
      'relative',
      'bg-white ax-shadow px-2 py-1 rounded-b-md',
    ),
  },
  file: {
    className: classNames(
      'flex items-center flex-wrap',
      'p-4 border border-gray-300 rounded gap-2 mb-2',
      'last:mb-0',
    ),
  },
  thumbnail: {
    className: 'shrink-0',
  },
  fileName: {
    className: 'mb-2',
  },
  fileSize: {
    className: 'mr-2',
  },
  uploadIcon: {
    className: 'mr-2',
  },
};
